module.exports = __webpack_public_path__ + "media/honey-icons/icon-security-away-white-b35a6169.svg";